var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2758_2061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2758_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 41.4C8.73294 41.4 8.01628 41.1166 7.44961 40.55C6.88294 39.9833 6.59961 39.2666 6.59961 38.4V19.6C6.59961 18.7333 6.88294 18.0166 7.44961 17.45C8.01628 16.8833 8.73294 16.6 9.59961 16.6H20.5996V7.99998C20.5996 7.61498 20.7368 7.28531 21.0111 7.01097C21.2851 6.73697 21.6146 6.59998 21.9996 6.59998H25.9996C26.3846 6.59998 26.7143 6.73697 26.9886 7.01097C27.2626 7.28531 27.3996 7.61498 27.3996 7.99998V16.6H38.3996C39.2663 16.6 39.9829 16.8833 40.5496 17.45C41.1163 18.0166 41.3996 18.7333 41.3996 19.6V38.4C41.3996 39.2666 41.1163 39.9833 40.5496 40.55C39.9829 41.1166 39.2663 41.4 38.3996 41.4H9.59961ZM12.7996 34.5H23.1996V34.4C23.1996 33.9803 23.0853 33.5915 22.8566 33.2335C22.6279 32.8755 22.3089 32.5976 21.8996 32.4C21.2656 32.1333 20.6238 31.9333 19.9741 31.8C19.3244 31.6666 18.6663 31.6 17.9996 31.6C17.3329 31.6 16.6748 31.6666 16.0251 31.8C15.3754 31.9333 14.7336 32.1333 14.0996 32.4C13.6903 32.5976 13.3713 32.8755 13.1426 33.2335C12.9139 33.5915 12.7996 33.9803 12.7996 34.4V34.5ZM27.9996 31.4H35.9996V30H27.9996V31.4ZM17.9876 30C18.5956 30 19.1163 29.7873 19.5496 29.362C19.9829 28.9363 20.1996 28.4196 20.1996 27.812C20.1996 27.204 19.9869 26.6833 19.5616 26.25C19.1359 25.8166 18.6193 25.6 18.0116 25.6C17.4036 25.6 16.8829 25.8126 16.4496 26.238C16.0163 26.6636 15.7996 27.1803 15.7996 27.788C15.7996 28.396 16.0123 28.9166 16.4376 29.35C16.8633 29.7833 17.3799 30 17.9876 30ZM27.9996 27H35.9996V25.6H27.9996V27ZM21.9996 20H25.9996V7.99998H21.9996V20Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.f09e8710f76a1be37b7793011a331958.svg";
export { ForwardRef as ReactComponent };